<template>
  <basic-container id="settingForm">
    <el-form
      ref="otherSettingForm"
      :model="otherSettingForm"
      label-width="180px"
      margin-top="20"
      :rules="settingRules"
    >
      <el-row>
        <el-col style="margin-top: 15px">
          <strong>场内付款设置</strong>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10" style="height: 35px">
          <el-form-item label="场内缴费允许停留时间" prop="allowStayMinutes">
            <el-input type="number" v-model="otherSettingForm.allowStayMinutes">
              <template slot="append">分钟</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" offset="1" style="height: 35px">
          <div style="font-size: 10px; margin-top: 12px">
            不配置则默认为15分钟，超过后重新计算停车费
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="margin-top: 15px">
          <strong>识别设置</strong>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10" style="height: 35px">
          <el-form-item label="车牌重复识别时间" prop="repeatIdentitySeconds">
            <el-input type="number" v-model="otherSettingForm.repeatIdentitySeconds">
              <template slot="append">秒</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12" offset="1" style="height: 35px">
          <div style="font-size: 10px; margin-top: 12px">
            不配置则默认为60秒，超过后生成新的识别记录
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="margin-top: 15px">
          <strong>道闸操控</strong>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="10" style="height: 35px">
          <el-form-item label="遥控/页面关联数据操作" prop="useTeleControl">
            <el-switch v-model="otherSettingForm.useTeleControl"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12" offset="1" style="height: 35px">
          <div style="font-size: 10px; margin-top: 12px">默认不启用</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="margin-top: 15px">
          <strong>公共通道配置</strong>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="height: 35px">
          <el-form-item prop="linkPassageId" label="公共通道">
            <el-select v-model="otherSettingForm.linkPassageId" clearable>
              <el-option
                v-for="item in passageList"
                :key="item.id"
                :label="item.passageName"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <span style="margin-left: 10px">连接区域</span>
            <el-select v-model="otherSettingForm.linkRegionId" clearable>
              <el-option
                v-for="item in regionList"
                :key="item.id"
                :label="item.spaceName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="margin-top: 15px">
          <strong>一位多车收费模式 (启用后同车主的临停车可以共享月卡车位)</strong>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10" style="height: 35px">
          <el-form-item label="是否启用一位多车" prop="useOneSpaceMoreCar">
            <el-switch v-model="otherSettingForm.useOneSpaceMoreCar"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12" offset="1" style="height: 35px">
          <div style="font-size: 10px; margin-top: 12px">默认不启用</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10" style="height: 35px;">
          <el-form-item label="车位组多位多车计费规则" prop="oneSpaceMoreCarFeeType">
            <el-select v-model="otherSettingForm.oneSpaceMoreCarFeeType" placeholder="请选择">
              <el-option v-for="item in oneSpaceMoreCarFeeTypeList"
                         :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10" style="height: 35px;">
          <el-form-item label="月卡车一位多车计费规则" prop="oneMonthCarMoreCarFeeType">
            <el-select v-model="otherSettingForm.oneMonthCarMoreCarFeeType" placeholder="请选择">
              <el-option v-for="item in oneSpaceMoreCarFeeTypeList"
                         :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="margin-top: 15px">
          <strong>无感停车设置</strong>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10" style="height: 35px">
          <el-form-item label="是否启用无感停车" prop="useSenselessParking">
            <el-switch
              v-model="otherSettingForm.useSenselessParking"
              :active-value="switchBoolValue.yes"
              :inactive-value="switchBoolValue.no"
            ></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12" offset="1" style="height: 35px">
          <div style="font-size: 10px; margin-top: 12px">默认不启用</div>
        </el-col>
      </el-row>
      <el-row v-if="otherSettingForm.useSenselessParking == switchBoolValue.yes">
        <el-col span="20">
          <el-form-item label="无感支付" prop="senselessParkTypes">
            <el-select
              style="width: 100%"
              v-model="otherSettingForm.senselessParkTypes"
              multiple
              placeholder="请选择无感支付"
            >
              <el-option
                v-for="item in noninductivePayTypeList"
                :key="item.id"
                :label="item.dictValue"
                :value="item.dictKey"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="20">
          <el-form-item label="微信支付分限额" prop="wechatScoreLimit">
            <el-input
              placeholder="请输入 微信支付分限额"
              maxlength="6"
              show-word-limit
              v-model="otherSettingForm.wechatScoreLimit"
              @input="wechatScoreLimitInput"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="margin-top: 15px">
          <strong>日志</strong>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10" style="height: 35px">
          <el-form-item label="是否启用日志" prop="useSenselessParking">
            <el-switch
              v-model="otherSettingForm.useLog"
              :active-value="switchBoolValue.yes"
              :inactive-value="switchBoolValue.no"
            ></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12" offset="1" style="height: 35px">
          <div style="font-size: 10px; margin-top: 12px">默认不启用</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="margin-top: 15px">
          <strong>月卡车配置</strong>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col span="24" style="margin-top: 20px">
          <div class="label">是否启用月卡车审核</div>
          <el-switch
            v-model="otherSettingForm.carUseReview"
            :active-value="true"
            :inactive-value="false"
          ></el-switch>
          <span style="font-size: 10px; margin-top: 12px; margin-left: 20px">默认不启用</span>
        </el-col>
        <el-col span="24" style="margin-top: 20px">
          <div class="label">月卡车快捷登记状态设置</div>
          <el-radio-group v-model="otherSettingForm.carMonthQuickAddStatus">
            <el-radio :label="1">待审核</el-radio>
            <el-radio :label="2">待付款</el-radio>
            <el-radio :label="3">以现金支付进行登记</el-radio>
          </el-radio-group>
        </el-col>
        <el-col span="24" style="margin-top: 20px">
          <div class="label">过期月卡车续费启用当前时间</div>
          <el-switch
            v-model="otherSettingForm.expiredCarUseNowDate"
            :active-value="true"
            :inactive-value="false"
          ></el-switch>
          <span style="font-size: 10px; margin-top: 12px; margin-left: 20px">默认不启用</span>
        </el-col>
        <el-col span="24" style="margin-top: 20px">
          <div class="label">移动端过期月卡车续费</div>
          <el-radio-group v-model="otherSettingForm.mobileExpiredCarUseNowDate">
            <el-radio :label="1">连续续约</el-radio>
            <el-radio :label="2">以当前日期续约</el-radio>
            <el-radio :label="3">以最近一次入场时间续约</el-radio>
          </el-radio-group>
        </el-col>
        <el-col span="24" style="margin-top: 20px">
          <div class="label">过期月卡车按外部临停车处理</div>
          <el-switch
            v-model="otherSettingForm.expiredMonthCarToNoOwnerCar"
            :active-value="true"
            :inactive-value="false"
          ></el-switch>
          <span style="font-size: 10px; margin-top: 12px; margin-left: 20px">默认不启用</span>
        </el-col>
        <el-col span="24" style="margin-top: 20px">
          <div class="label">月卡车收费类型</div>
          <el-select
            v-model="otherSettingForm.payTypeList"
            style="width: 500px"
            multiple
            placeholder="请选择 月卡车收费类型"
          >
            <el-option
              v-for="item in payTypeList"
              :key="item.id"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="margin-top: 15px">
          <strong>固定车配置</strong>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="10" style="height: 35px">
          <el-form-item label="是否启用固定车审核" prop="fixedCarReview">
            <el-switch v-model="otherSettingForm.fixedCarReview"></el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="12" offset="1" style="height: 35px">
          <div style="font-size: 10px; margin-top: 12px">默认启用</div>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="margin-top: 15px">
          <strong>无法识别车辆类型收费配置</strong>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="height: 35px">
          <el-form-item prop="defaultFeeRuleType">
            <el-radio-group v-model="otherSettingForm.defaultFeeRuleType">
              <el-radio :label="1">非业主小车</el-radio>
              <el-radio :label="2">非业主大车</el-radio>
              <el-radio :label="3">业主小车</el-radio>
              <el-radio :label="4">业主大车</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="margin-top: 15px">
          <strong>交班设置</strong>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="height: 35px">
          <el-form-item label="统计场内订单金额" prop="calculateInParkBill">
            <el-switch
              v-model="otherSettingForm.calculateInParkBill"
              :active-value="switchBoolValue.yes"
              :inactive-value="switchBoolValue.no"
            ></el-switch>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="margin-top: 15px">
          <strong>播报屏显</strong>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" style="height: 35px">
          <el-form-item prop="voiceShowCarType" label="月卡车">
            <span style="margin-left: 10px">语音播报</span>
            <el-select v-model="voiceShowCarType.voice1">
              <el-option
                v-for="item in carTypeList"
                :key="item.id"
                :label="item.dictValue"
                :value="item.dictValue"
              >
              </el-option>
            </el-select>
            <span style="margin-left: 10px">屏显</span>
            <el-input
              v-model="voiceShowCarType.show1"
              style="width: 150px"
              show-word-limit
              maxlength="5"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" style="height: 35px">
          <el-form-item prop="voiceShowCarType" label="临时车">
            <span style="margin-left: 10px">语音播报</span>
            <el-select v-model="voiceShowCarType.voice2">
              <el-option
                v-for="item in carTypeList"
                :key="item.id"
                :label="item.dictValue"
                :value="item.dictValue"
              >
              </el-option>
            </el-select>
            <span style="margin-left: 10px">屏显</span>
            <el-input
              v-model="voiceShowCarType.show2"
              style="width: 150px"
              show-word-limit
              maxlength="5"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" style="height: 35px">
          <el-form-item prop="voiceShowCarType" label="储值车">
            <span style="margin-left: 10px">语音播报</span>
            <el-select v-model="voiceShowCarType.voice3">
              <el-option
                v-for="item in carTypeList"
                :key="item.id"
                :label="item.dictValue"
                :value="item.dictValue"
              >
              </el-option>
            </el-select>
            <span style="margin-left: 10px">屏显</span>
            <el-input
              v-model="voiceShowCarType.show3"
              style="width: 150px"
              show-word-limit
              maxlength="5"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" style="height: 35px">
          <el-form-item prop="voiceShowCarType" label="白名单">
            <span style="margin-left: 10px">语音播报</span>
            <el-select v-model="voiceShowCarType.voice4">
              <el-option
                v-for="item in carTypeList"
                :key="item.id"
                :label="item.dictValue"
                :value="item.dictValue"
              >
              </el-option>
            </el-select>
            <span style="margin-left: 10px">屏显</span>
            <el-input
              v-model="voiceShowCarType.show4"
              style="width: 150px"
              show-word-limit
              maxlength="5"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col style="margin-top: 15px">
          <strong>登记车辆临停收费规则</strong>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="height: 35px">
          <el-form-item prop="expiredCarType" label="过期月卡车">
            <span style="margin-left: 10px">收费规则</span>
            <el-select v-model="expiredCarType.monthCar">
              <el-option
                v-for="item in expiredCarFeeRule"
                :key="item.id"
                :label="item.ruleName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24" style="height: 35px">
          <el-form-item prop="expiredCarType" label="固停车">
            <span style="margin-left: 10px">收费规则</span>
            <el-select v-model="expiredCarType.fixedCar">
              <el-option
                v-for="item in expiredCarFeeRule"
                :key="item.id"
                :label="item.ruleName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" style="height: 35px">
          <el-form-item prop="expiredCarType" label="储值车">
            <span style="margin-left: 10px">收费规则</span>
            <el-select v-model="expiredCarType.storedCar">
              <el-option
                v-for="item in expiredCarFeeRule"
                :key="item.id"
                :label="item.ruleName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col :span="24" style="height: 35px">
          <el-form-item prop="voiceShowCarType" label="白名单">
            <span style="margin-left: 10px">收费规则</span>
            <el-select v-model="expiredCarType.whiteCar">
              <el-option
                v-for="item in expiredCarFeeRule"
                :key="item.id"
                :label="item.ruleName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row>
        <el-col style="margin-top: 15px">
          <strong>开启充电站优惠</strong>
        </el-col>
      </el-row>
      <el-row :gutter="24">
        <el-col :span="24">
          <el-form-item label="开启充电站优惠" prop="openChargeCoupon">
            <el-switch v-model="otherSettingForm.openChargeCoupon"> </el-switch>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="充电站优惠发券商家" prop="shopId">
            <el-select
              v-model="otherSettingForm.shopId"
              style="width: 50%"
              placeholder="请选择"
              @change="getShopCouponList"
            >
              <el-option
                v-for="item in shopList"
                :key="item.id"
                :label="item.shopName"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24" style="height: 57px">
          <el-form-item label="充电完成发券设置" prop="code">
            <div style="display: flex; height: 57px">
              <div>充电时长大于</div>
              <el-input-number
                style="width: 30%"
                size="mini"
                v-model="otherSettingForm.lowTime"
                :min="0"
                :max="9999"
                label="描述文字"
              ></el-input-number>
              <div>分钟</div>
              ，发送优惠券
              <el-select
                v-model="otherSettingForm.carCouponIssueId"
                style="width: 25%"
                placeholder="请选择"
                :disabled="!otherSettingForm.shopId"
              >
                <el-option
                  v-for="item in couponList"
                  :key="item.id"
                  :label="item.couponName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
              一张
            </div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </basic-container>
</template>

<script>
import {
  getDetail,
  update,
  shopSelections,
  getIssueList,
  spaceBasePayType,
} from '@/api/v4ward/park/carv2/carv4wardsettings';
import { getDictionary } from '@/api/common';
import { mapGetters } from 'vuex';
import { v4wardMessageTypes, latestVersion } from '@/views/v4ward/carv2/merge/api/park-merge';
import { cronValidator } from '@/util/validate';
import { getList } from '@/api/v4ward/park/tempcarv2/cartempcarfeerule';
import { getOutPassage } from '@/api/v4ward/carv2/carinoutinfo';
import { getRegionList } from '@/api/v4ward/carv2/cargroup';

export default {
  props: {
    saveBtnShow: false,
    parkSpace: {},
  },
  data() {
    var numberCheck = (rule, value, callback) => {
      if (typeof value !== 'number' && isNaN(value)) {
        callback(new Error('请输入数字！'));
      } else if (value < rule.min || value > rule.max) {
        callback(new Error('有效数据' + rule.min + '-' + rule.max + '！'));
      } else {
        callback();
      }
    };
    return {
      passageList:[],
      regionList:[],
      fixedCarReview:'',
      useTeleControl:'',
      oneSpaceMoreCarFeeTypeList:[
        {value: 1,label: '默认模式'},
        {value: 2,label: '主副车位'},
        {value: 3,label: '先到先得'}
      ],
      voiceShowCarType: {
        voice1: '',
        show1: '',
        voice2: '',
        show2: '',
        voice3: '',
        show3: '',
        voice4: '',
        show4: '',
      },
      expiredCarType:{
        monthCar:'',
        fixedCar:'',
        storedCar:'',
        whiteCar:'',
        crossAreaMonthCar:'',
      },
      expiredCarFeeRule:[],
      carTypeList: [],
      next: false,
      senselessParkTypes: [],
      noninductivePayTypeList: [],
      shopList: [], //商家列表
      couponList: [], //优惠券
      showChargingStationSettingForm: false,
      submitting: false,
      paramType: 0,
      showMatchSettingForm: false,
      showJobSettingForm: false,
      showOtherSettingForm: true,
      settings: '',
      click: false,
      messageTypeList: [],
      query: {},
      formData: {},
      matchSettingForm: {
        plateMatchOpen: 0,
        ignoreFirstLetter: 0,
        matchPlus: 0,
      },
      otherSettingForm: {
        fixedCarReview:'',
        useTeleControl:'',
        oneSpaceMoreCarFeeType: '',
        oneMonthCarMoreCarFeeType: '',
        allowStayMinutes: 15,
        repeatIdentitySeconds: 60,
        recEffectiveMinutes: 1,
        serverBilling: 0,
        useParkFull: 'false',
        senselessParkTypes: '',
        carMonthQuickAddStatus: 1,
        mobileExpiredCarUseNowDate: 1,
        expiredMonthCarToNoOwnerCar: 'false',
        defaultFeeRuleType: 1,
        calculateInParkBill: 'false',
        openChargeCoupon: false,
        shopId: '',
        carCouponIssueId: '',
        voiceShowCarType: {
          monthCarTypeSetting: {
            voice: '',
            show: '',
          },
          tempCarTypeSetting: {
            voice: '',
            show: '',
          },
          storedCarTypeSetting: {
            voice: '',
            show: '',
          },
          whiteCarTypeSetting: {
            voice: '',
            show: '',
          },
        },
      },
      jobSettingForm: {
        openImageUpload: 0,
        imageUploadCron: '',
        imageCompressWidth: 600,
        imageCompressHeight: 380,
        autoRestartAfterUpdate: 1,
        updateCheckCron: '',
        imageClearExpireDays: 30,
        imageClearExpireCron: '0 0 */8 * * ? *',
        credentialPullInterval: 5,
        credentialStatusCheckCron: '0 0 1 * * ? *',
        messageResendFirstDelay: 10,
        messageResendInterval: 10,
        resendTypes: '',
        notSaveTypes: '',
      },
      latestVersion: 'v1.0.0',
      selectedNotSaveTypes: [],
      selectedResendTypes: [],
      defaultResendMessageTypes: [
        'PARK_CAR_IN',
        'PARK_CAR_OUT',
        'PARK_TEMPCAR_BILL',
        'PARK_HANDOVER',
        'PARK_UNUSUAL',
      ],
      defaultNotSaveType: ['EQUIPMENT_ON_LINE', 'PARK_CREDENTIAL'],
      switchValue: { yes: 1, no: 0 },
      switchBoolValue: { yes: true, no: false },
      settingRules: {
        imageUploadCron: [
          { message: '请输入cron表达式', trigger: 'blur' },
          { message: '请输入cron表达式', trigger: 'change', validator: cronValidator },
        ],
        updateCheckCron: [
          { required: true, message: '请输入cron表达式', trigger: 'blur' },
          { message: '请输入正确的cron表达式', trigger: 'change', validator: cronValidator },
        ],
        imageCompressWidth: [
          { required: true, message: '请输入图片宽度', trigger: 'blur' },
          { validator: numberCheck, min: 100, max: 1000, trigger: 'blur' },
        ],
        imageCompressHeight: [
          { required: true, message: '请输入图片高度', trigger: 'blur' },
          { validator: numberCheck, min: 100, max: 1000, trigger: 'blur' },
        ],
        allowStayMinutes: [
          { required: true, message: '请输入停留时间', trigger: 'blur' },
          { validator: numberCheck, min: 5, max: 120, trigger: 'blur' },
        ],
        repeatIdentitySeconds: [
          { required: true, message: '请输入重复识别时间', trigger: 'blur' },
          { validator: numberCheck, min: 5, max: 300, trigger: 'blur' },
        ],
        imageClearExpireDays: [
          { required: true, message: '请输入图片保存时间', trigger: 'blur' },
          { validator: numberCheck, min: 7, max: 120, trigger: 'blur' },
        ],
        imageClearExpireCron: [
          { required: true, message: '请输入cron表达式', trigger: 'blur' },
          { message: '请输入正确的cron表达式', trigger: 'change', validator: cronValidator },
        ],
        credentialPullInterval: [
          { required: true, message: '请输入月卡车拉取时间间隔', trigger: 'blur' },
          { validator: numberCheck, min: 5, max: 120, trigger: 'blur' },
        ],
        credentialStatusCheckCron: [
          { required: true, message: '请输入cron表达式', trigger: 'blur' },
          { message: '请输入正确的cron表达式', trigger: 'change', validator: cronValidator },
        ],
        messageResendFirstDelay: [
          { required: true, message: '请输入时间间隔', trigger: 'blur' },
          { validator: numberCheck, min: 5, max: 60, trigger: 'blur' },
        ],
        senselessParkTypes: [{ required: true, message: '请选择无感支付', trigger: 'change' }],
        version: [{ required: true, message: '请输入版本号', trigger: 'blur' }],

        noPlateCarTag: [
          { required: true, min: 2, max: 7, message: '请输入无牌车标记', trigger: 'blur' },
        ],
        messageResendInterval: [
          { required: true, message: '请输入时间间隔', trigger: 'blur' },
          { validator: numberCheck, min: 10, max: 60, trigger: 'blur' },
        ],
        identityDuplicatedTime: [
          { required: true, message: '请输入车牌识别间隔时间', trigger: 'blur' },
          { validator: numberCheck, min: 30, max: 300, trigger: 'blur' },
        ],
        recEffectiveMinutes: [
          { required: true, message: '请输入识别有效时间', trigger: 'blur' },
          { validator: numberCheck, min: 1, max: 5, trigger: 'blur' },
        ],
      },
    };
  },
  computed: {
    ...mapGetters(['permission']),
  },
  created() {
    this.initMessageTypeList();
    this.initCarType();
    this.getShopList();
    this.initPassageList();
    this.initRegionList();
    this.onLoad();
  },

  methods: {
    initPassageList() {
      getOutPassage({spaceId: this.parkSpace.id}).then((res) => {
        this.passageList = res.data;
      });
    },
    initRegionList() {
      getRegionList({spaceId: this.parkSpace.id}).then((res) => {
        this.regionList = res.data;
      });
    },
    initCarType() {
      console.log("initcartype",this.parkSpace)
      getDictionary('car_type_voice').then((res) => {
        this.carTypeList = res.data;
      });
      // 获取所有支付方式
      spaceBasePayType().then((res) => {
        this.payTypeList = res.data;
      });
      getList({parkingLotId: this.parkSpace.id}).then((res) => {
        this.expiredCarFeeRule = res.data.records;
      });
    },
    formSubmit(next) {
      if (next) {
        this.next = true;
        // 测试使用
        this.$emit('getQuestionResult', this.next);
      } else {
        this.next = false;
      }
      this.saveSetting();
    },
    shopIdChange() {},
    //获取商家自制优惠券
    getShopCouponList() {
      this.otherSettingForm.carCouponIssueId = '';
      getIssueList({
        shopId: this.otherSettingForm.shopId,
        parkingLotId: this.parkSpace.id,
        // id: this.otherSettingForm.carCouponIssueId
      }).then((res) => {
        this.couponList = res.data;
      });
    },
    //获取商家列表
    getShopList() {
      shopSelections({
        parkingLotId: this.parkSpace.id,
      }).then((res) => {
        this.shopList = res.data;
      });
    },
    initMessageTypeList() {
      v4wardMessageTypes().then((res) => {
        this.messageTypeList = res.data;
      });
      latestVersion().then((res) => {
        this.latestVersion = res.data.releaseVersion;
      });
      getDictionary('noninductive-pay-type').then((res) => {
        this.noninductivePayTypeList = res.data;
        if (!this.otherSettingForm.senselessParkTypes) {
          res.data.forEach((ele) => {
            this.senselessParkTypes.push(ele.dictKey);
          });
        }
      });
    },
    wechatScoreLimitInput(e) {
      this.otherSettingForm.wechatScoreLimit = this.outNumber(e);
    },
    outNumber(e, max = 800) {
      let value = e;
      value = value.replace(/[^\d.]/g, ''); //清除“数字”和“.”以外的字符
      value = value.replace(/\.{2,}/g, '.'); //只保留第一个. 清除多余的
      value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.');
      value = value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3'); //只能输入两个小数
      if (value.indexOf('.') < 0 && value != '') {
        //以上已经过滤，此处控制的是如果没有小数点，首位不能为类似于 01、02的金额
        value = parseFloat(value);
      }

      if (value == '.') {
        value = '0.';
      }
      if (Number(value) > Number(max)) {
        value = max;
      }
      return value;
    },

    // 切换无感支付方式
    noninductivePayTypeChange(e) {
      if (e[0]) {
        this.otherSettingForm.senselessParkTypes = e.join(',');
        console.log(this.otherSettingForm.senselessParkTypes);
      } else {
        this.otherSettingForm.senselessParkTypes = '';
      }
      console.log(this.otherSettingForm);
    },
    async onLoad(spaceId) {
      let parkingLotId = this.parkSpace.id;
      if(spaceId){
        parkingLotId = spaceId;
      }
      getDetail({ parkingLotId, paramType: 9 }).then(({ data }) => {
        this.formData = data;
        if (this.vdui.isNotEmpty(data.settings)) {
          // 其他配置表单
          let obj = JSON.parse(data.settings);
          obj.openChargeCoupon = false;
          obj.carCouponIssueId = '';
          obj.shopId = '';
          obj.lowTime = '';
          if (obj.repeatIdentitySeconds == 'undefined') {
            obj.repeatIdentitySeconds = '';
          }
          console.log(">>>obj>>>>>>>>>>", obj)
          // this.otherSettingForm = JSON.parse(data.settings);
          this.otherSettingForm = obj;
          console.log('this.otherSettingForm>>>>', this.otherSettingForm)
          if (this.otherSettingForm.carMonthQuickAddStatus == 'undefined') {
            this.$set(this.otherSettingForm, 'carMonthQuickAddStatus', 1);
          }
          if (!this.otherSettingForm.repeatIdentitySeconds) {
            this.$set(this.otherSettingForm, 'repeatIdentitySeconds', 60);
          }
          if (this.otherSettingForm.mobileExpiredCarUseNowDate == 'undefined') {
            this.$set(this.otherSettingForm, 'mobileExpiredCarUseNowDate', 1);
          }
          if (this.otherSettingForm.expiredMonthCarToNoOwnerCar == 'undefined') {
            this.$set(this.otherSettingForm, 'expiredMonthCarToNoOwnerCar', 'false');
          }
          if (this.otherSettingForm.defaultFeeRuleType == 'undefined') {
            this.$set(this.otherSettingForm, 'defaultFeeRuleType', 1);
          }
          if (this.otherSettingForm.calculateInParkBill == 'undefined') {
            this.$set(this.otherSettingForm, 'calculateInParkBill', 'false');
          }
          if (this.otherSettingForm.fixedCarReview == 'undefined') {
            this.$set(this.otherSettingForm, 'fixedCarReview', 'true');
          }
          if (this.otherSettingForm.useTeleControl == 'undefined') {
            this.$set(this.otherSettingForm, 'useTeleControl', 'false');
          }
          if (this.otherSettingForm.useOneSpaceMoreCar && this.vdui.isEmpty(this.otherSettingForm.oneSpaceMoreCarFeeType)) {
            this.$set(this.otherSettingForm, 'oneSpaceMoreCarFeeType', 1);
          }
          if (this.vdui.isEmpty(this.otherSettingForm.oneMonthCarMoreCarFeeType)) {
            this.$set(this.otherSettingForm, 'oneMonthCarMoreCarFeeType', 1);
          }
          if (this.vdui.isEmpty(this.otherSettingForm)) {
            this.otherSettingForm = this.defaultOtherSettingForm();
          }
          // 充电配置表单
          if (this.otherSettingForm.chargeCouponSettingsDTO) {
            this.otherSettingForm.openChargeCoupon = Boolean(
              this.otherSettingForm.chargeCouponSettingsDTO.openChargeCoupon
            );
            this.otherSettingForm.shopId = this.otherSettingForm.chargeCouponSettingsDTO.shopId;
            this.otherSettingForm.lowTime = this.otherSettingForm.chargeCouponSettingsDTO.lowTime;
            this.otherSettingForm.carCouponIssueId =
              this.otherSettingForm.chargeCouponSettingsDTO.carCouponIssueId;
          }
          //车辆类型的语音设置
          if (this.otherSettingForm.voiceShowCarType) {
            if (this.otherSettingForm.voiceShowCarType.monthCarTypeSetting) {
              this.voiceShowCarType.voice1 =
                this.otherSettingForm.voiceShowCarType.monthCarTypeSetting.voice;
              this.voiceShowCarType.show1 =
                this.otherSettingForm.voiceShowCarType.monthCarTypeSetting.show;
            }
            if (this.otherSettingForm.voiceShowCarType.tempCarTypeSetting) {
              this.voiceShowCarType.voice2 =
                this.otherSettingForm.voiceShowCarType.tempCarTypeSetting.voice;
              this.voiceShowCarType.show2 =
                this.otherSettingForm.voiceShowCarType.tempCarTypeSetting.show;
            }
            if (this.otherSettingForm.voiceShowCarType.storedCarTypeSetting) {
              this.voiceShowCarType.voice3 =
                this.otherSettingForm.voiceShowCarType.storedCarTypeSetting.voice;
              this.voiceShowCarType.show3 =
                this.otherSettingForm.voiceShowCarType.storedCarTypeSetting.show;
            }
            if (this.otherSettingForm.voiceShowCarType.whiteCarTypeSetting) {
              this.voiceShowCarType.voice4 =
                this.otherSettingForm.voiceShowCarType.whiteCarTypeSetting.voice;
              this.voiceShowCarType.show4 =
                this.otherSettingForm.voiceShowCarType.whiteCarTypeSetting.show;
            }
          }

          //过期车辆收费规则设置
          if(this.otherSettingForm.expiredCarType){
            if (this.otherSettingForm.expiredCarType.expiredMonthCarFeeRule) {
              this.expiredCarType.monthCar =
                this.otherSettingForm.expiredCarType.expiredMonthCarFeeRule+"";
            }
            if (this.otherSettingForm.expiredCarType.expiredFixedCarFeeRule) {
              this.expiredCarType.fixedCar =
                this.otherSettingForm.expiredCarType.expiredFixedCarFeeRule+"";
            }
            if (this.otherSettingForm.expiredCarType.expiredStoredCarFeeRule) {
              this.expiredCarType.storedCar =
                this.otherSettingForm.expiredCarType.expiredStoredCarFeeRule+"";
            }
            if (this.otherSettingForm.expiredCarType.expiredWhiteCarFeeRule) {
              this.expiredCarType.whiteCar =
                this.otherSettingForm.expiredCarType.expiredWhiteCarFeeRule+"";
            }
            if (this.otherSettingForm.expiredCarType.crossAreaMonthCarFeeRule) {
              this.expiredCarType.crossAreaMonthCar =
                this.otherSettingForm.expiredCarType.crossAreaMonthCarFeeRule+"";
            }
          }
        } else {
          this.matchSettingForm = {
            plateMatchOpen: 0,
            ignoreFirstLetter: 0,
            matchPlus: 0,
          };
          this.otherSettingForm = this.defaultOtherSettingForm();
        }
        getIssueList({
          shopId: this.otherSettingForm.shopId,
          parkingLotId: this.parkSpace.id,
          // id: this.otherSettingForm.carCouponIssueId
        }).then((res) => {
          this.couponList = res.data;
        });
      });
    },
    // 默认字段
    defaultOtherSettingForm() {
      return {
        linkPassageId:'',
        linkRegionId:'',
        fixedCarReview:'',
        useTeleControl:'',
        oneSpaceMoreCarFeeType: '',
        oneMonthCarMoreCarFeeType: '',
        allowStayMinutes: 15,
        repeatIdentitySeconds: 60,
        recEffectiveMinutes: 1,
        useParkFull: 'false',
        serverBilling: 0,
        carMonthQuickAddStatus: 1,
        mobileExpiredCarUseNowDate: 1,
        expiredMonthCarToNoOwnerCar: 'false',
        defaultFeeRuleType: 1,
        calculateInParkBill: 'false',
        noPlateCarTag: '12345',
        identityDuplicatedTime: 60,
        useEarthSense: 'false',
        useOneSpaceMoreCar: 'false',
        useSenselessParking: 'false',
        useLog: 'false',
        version: this.latestVersion,
        openChargeCoupon: 0,
        shopId: '',
        lowTime: '',
        carCouponIssueId: '',
      };
    },
    saveSetting() {
      var submitForm = this.setParam();
      if (submitForm == null) {
        return;
      }
      submitForm.validate((valid) => {
        if (valid) {
          this.submitting = true;
          //其它参数用新的form
          update(this.formData)
            .then((res) => {
              this.submitting = false;
              this.$message.success('修改成功!');
              this.otherSettingForm.openChargeCoupon = Boolean(
                this.otherSettingForm.openChargeCoupon
              );
              this.$emit('getQuestionResult', this.next);
            })
            .catch((err) => {
              this.submitting = false;
            });
        }
      });
    },
    setParam() {
      if (
        this.vdui.isNotEmpty(this.otherSettingForm.useParkFull) &&
        this.otherSettingForm.useParkFull === 'true'
      ) {
        //启用车位已满逻辑，地感信号启用
        this.otherSettingForm.useEarthSense = 'true';
      }
      this.otherSettingForm.openChargeCoupon = Number(this.otherSettingForm.openChargeCoupon);
      this.otherSettingForm.chargeCouponSettingsDTO = {
        openChargeCoupon: this.otherSettingForm.openChargeCoupon,
        shopId: this.otherSettingForm.shopId,
        lowTime: this.otherSettingForm.lowTime,
        carCouponIssueId: this.otherSettingForm.carCouponIssueId,
      };

      this.otherSettingForm.voiceShowCarType = {
        monthCarTypeSetting: {
          voice: this.voiceShowCarType.voice1,
          show: this.voiceShowCarType.show1,
        },
        tempCarTypeSetting: {
          voice: this.voiceShowCarType.voice2,
          show: this.voiceShowCarType.show2,
        },
        storedCarTypeSetting: {
          voice: this.voiceShowCarType.voice3,
          show: this.voiceShowCarType.show3,
        },
        whiteCarTypeSetting: {
          voice: this.voiceShowCarType.voice4,
          show: this.voiceShowCarType.show4,
        },
      };
      this.otherSettingForm.expiredCarType = {
        expiredMonthCarFeeRule: this.expiredCarType.monthCar,
        expiredFixedCarFeeRule: this.expiredCarType.fixedCar,
        expiredStoredCarFeeRule: this.expiredCarType.storedCar,
        expiredWhiteCarFeeRule: this.expiredCarType.whiteCar,
        crossAreaMonthCarFeeRule: this.expiredCarType.crossAreaMonthCar,
      };
      this.formData.settings = JSON.stringify(this.otherSettingForm);

      this.formData.remark = '系统配置-其它配置-充电站优惠设置';
      return this.$refs.otherSettingForm;
    },
    randomCron() {
      var cron = '';
      cron = cron + Math.ceil(Math.random() * 60) + ' ';
      cron = cron + Math.ceil(Math.random() * 60) + ' ';
      cron = cron + Math.ceil(Math.random() * 7) + ' * * ? *';
      return cron;
    },
  },
};
</script>

<style scoped>
.label {
  width: 200px;
  display: inline-block;
  text-align: right;
  margin-right: 10px;
}
#parkV4wardSettingsLine .el-divider--vertical {
  display: inline-block;
  width: 1px;
  height: 10em;
  margin: 0 1px;
  vertical-align: middle;
  position: relative;
}

#parkV4wardSettingsLine .el-card__body {
  padding: 1px !important;
}

#settingForm .el-input__inner {
  height: 30px;
  line-height: 30px;
}

#settingForm .el-form-item__content .el-input-group {
  vertical-align: middle;
}

#settingForm .el-input-group__append,
.el-input-group__prepend {
  padding: 0 5px;
}
</style>
